import { render, staticRenderFns } from "./CompanySizeContent.vue?vue&type=template&id=4fd4ed8e"
import script from "./CompanySizeContent.vue?vue&type=script&lang=js"
export * from "./CompanySizeContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports